<template>
  <div id="app">
    <div ref="foo"></div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      logout: {}
    }
  },
  mounted() {
    sessionStorage.clear()

    // Clear any cache
    localStorage.removeItem('organisationId')
    localStorage.removeItem('brandPrimary')
    localStorage.removeItem('brandSecondary')
  }
}
</script>
